import React from 'react';
import { Body } from '@edreamsodigeo/prisma-design-system';
import StopoverQuantityMessage from '@components/Results/Components/StopoverQuantity/StopoverQuantityMessage';
import { TransportType } from '../../../../../generated/graphql';

export interface StopoverQuantityProps {
  quantity: number;
  transportTypes: TransportType[];
}

const StopoverQuantity: React.FC<StopoverQuantityProps> = ({
  quantity,
  transportTypes,
}) => {
  return (
    <Body type="xSmall" color={quantity === 0 ? 'green.50' : 'neutral.70'}>
      <StopoverQuantityMessage
        quantity={quantity}
        transportTypes={transportTypes}
      />
    </Body>
  );
};

export default StopoverQuantity;
